import { Entidad } from "../../../data/Entidad";
import { CFinanzaPagoEnLineaEstado } from "../../../data/entidad/FinanzasEstadoCuenta";
import { _DICC_METODO_PAGO } from "../../../data/modulo/FinanzaMetodoPago";
import { _DICC_ALUMNO_MOVPAGO_FOLIO } from "../../../data/modulo/FinanzasEstadoCuenta";
import { DataModuloMain } from "../../../data/ModuloMain";
import _L from "../../../util/Labels";
import { UIUtilFormat } from "../../util/Format";
import { UIUtilTime } from "../../util/Time";
import { UIUtilViewData } from "../../util/ViewData";

import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;

// type IMovimiento = Entidad.IFinanzaEdoCtaMovimiento;
type IMetodoPago = Entidad.IFinanzaMetodoPago;


export namespace AlumnoEdoCtaUtil {
    export const ID_METODOPAGO_ENLINEA_TEMP = -1;
    export enum CTableColumns {
        Periodo = "Periodo",
        Descripcion = "Cargo",
        /** Valor de: Cargo, descuento  */
        Valor = "Valor",
        PagoAbono = "PagoAbono",
        Saldo = "Saldo",
        Recargo = "Recargo",
        FechaVencimiento = "FechaVencimiento",
        FechaPago = "FechaPago",
        MetodoPago = "MetodoPago"
    }

    export interface IMovimientoTbl extends Entidad.IFinanzaEdoCtaMovimiento {
        Periodo?: string;
        /** Solo para configuración de tabla */
        PagoAbono?: string;
        /** Solo para configuración de tabla */
        FechaPago?: string;
        /** Solo para configuración de tabla */
        MetodoPago?: string;
    }

    export interface ICurrentData {
        IdAlumno: number;
        AlumnoNombre: string;
        NoCuenta: string;
        Tutoes: string[];
        StrNivel: string;

        StrPeriodo: string;
        SaldoPeriodo: number;
        SaldoPendiente: number;
        InteresesGenerados: number;
        TotalPago: number;
        MovimientosPeriodo: IMovimientoTbl[];

        MovimientosTbl_TopPeriodo: IMovimientoTbl[];
    }

    export interface IMovimientoDetalle extends Entidad.IFinanzaEdoCtaMovimientoDetalle {
        ParentMovimiento?: IMovimientoTbl;
        PagosMovRelacionados?: IMovimientoDetalle[];
        /** Se usa para pagos online pendientes */
        FechaVencimiento?: string;
    }

    export const MODULO_PERMISO = Entidad.CModulo.PanelFinanzasEdoCuenta;
    export const MODULO_LANG_KEY = Entidad.CModulo[Entidad.CModulo.PanelFinanzasEdoCuenta].toLowerCase();

    export function GetSaldoMovimiento(mov: Pick<IMovimientoTbl, "Saldo" | "Detalles">): number {
        let saldo = mov.Saldo;

        if (mov.Detalles?.length) {
            saldo = mov.Detalles[mov.Detalles.length - 1].Saldo;
        }

        return saldo;
    }

    export function GetMetodosPagoList(idEscuela: number): IMetodoPago[] {
        return Array.from(_DICC_METODO_PAGO.values())
            .filter(d => (d.IdEscuela == idEscuela && d.ProveedorElectronico == Entidad.CProveedorMetodoPagoElectronico.SinProveedor));
    }

    /** Recargo pendiente por pagar */
    export function GetAdeudoRecargoFromCargo(mov: Pick<IMovimientoTbl, "Detalles">): number {
        let totalRecargos = 0;
        if (mov.Detalles && mov.Detalles.length > 0) {
            mov.Detalles
                .filter((d, i) => (
                    d.Categoria == CCategoriaMov.Morosidad
                    && d.IdMetodoPago == 0
                    && (!mov.Detalles[i + 1] || ![CCategoriaMov.PagoParcial, CCategoriaMov.PagoCompleto].includes(mov.Detalles[i + 1].Categoria))
                ))
                .forEach(d => totalRecargos += d.Recargo);
        }
        return totalRecargos;
    }

    export function GetPagoValidation(inputPago: number, cargo: Pick<IMovimientoTbl, "Saldo" | "Detalles">) {
        type TFix = ("maxpay" | "minrecargo");
        const saldo = GetSaldoMovimiento(cargo);
        let decimales = (String(inputPago).split("."))[1];
        let decimalesValidos = (decimales ? (decimales.length > 0 && decimales.length < 3) : true);
        // let isValid = true;
        let message: string;
        let typeFix: TFix = "maxpay";

        if (inputPago <= 0) {
            message = _L("panelfinanzasedocuenta.notif_pagoinvalido")
                .replace("_VALOR", UIUtilFormat._CurrencyFmt(inputPago));
        }
        else if (inputPago < GetAdeudoRecargoFromCargo(cargo)) {
            message = _L("panelfinanzasedocuenta.notif_pagominrecargo");
            typeFix = "minrecargo";
        }
        else if (inputPago > saldo) {
            message = _L("panelfinanzasedocuenta.notif_pagoexcede");
        }
        else if (!decimalesValidos) {
            message = _L("panelfinanzasedocuenta.notif_cantsinvalid");
        }

        return {
            IsValid: (message == null),
            Message: message,
            TypeFix: typeFix
        }
    }

    export function MovDetalleIsPendingOnlinePayment(movDetalle: IMovimientoDetalle): boolean {
        const esPago = [CCategoriaMov.PagoCompleto, CCategoriaMov.PagoParcial].includes(movDetalle.Categoria)
        if (esPago) {
            const folioPagoInfo = _DICC_ALUMNO_MOVPAGO_FOLIO.get(movDetalle.FolioPago);
            return folioPagoInfo?.EstadoPago == CFinanzaPagoEnLineaEstado.Pendiente;
        }
        return false;
    }

    export function GetUIStrFieldData<TMode extends ("cargo" | "detalle")>(type: TMode, field: keyof IMovimientoTbl, dato: (TMode extends "cargo" ? IMovimientoTbl : IMovimientoDetalle)) {
        const detalle = ((type == "detalle") ? (dato as IMovimientoDetalle) : null);
        const cargo = ((type == "cargo") ? (dato as IMovimientoTbl) : null);
        const esPago = (detalle && ((detalle.Categoria == CCategoriaMov.PagoCompleto) || (detalle.Categoria == CCategoriaMov.PagoParcial)));
        let strText = "";

        switch (field) {
            case CTableColumns.Periodo:
                if (cargo) {
                    strText = cargo.Periodo;
                }
                break;
            case CTableColumns.Descripcion:
                strText = dato.Cargo; // cargo | descuento
                if (detalle) {
                    switch (detalle.Categoria) {
                        case CCategoriaMov.Morosidad:
                            strText = _L("panelfinanzasedocuenta.tag_recargomoroso");
                            break;
                        case CCategoriaMov.LlegadaAnticipada:
                        case CCategoriaMov.SalidaTarde:
                        case CCategoriaMov.PagoParcial:
                        case CCategoriaMov.PagoCompleto:
                            strText = UIUtilViewData._GetStr_CategoriaMovimiento(detalle.Categoria);
                            const folioPago = _DICC_ALUMNO_MOVPAGO_FOLIO.get(detalle.FolioPago);
                            if (folioPago) {
                                if (MovDetalleIsPendingOnlinePayment(detalle)) {
                                    strText += ` (${_L("general.pendiente").toLowerCase()})`;
                                }
                                strText += `\n${_L("panelfinanzasedocuenta.tag_folio")}: ${folioPago.Folio}`; // FIX_LANGUAGE
                                // strText += `\n${CFinanzaPagoEnLineaFormaPago[folioPago.FormaPago]}`;
                                /// strText += `\n${CFinanzaPagoEnLineaEstado[folioPago.EstadoPago]}`;
                            }
                            break;
                    }
                }
                break;
            case CTableColumns.Valor: // Cargo | descuento
                if (cargo) {
                    strText = UIUtilFormat._CurrencyFmt(cargo.Valor);
                }
                else if (detalle.Categoria == CCategoriaMov.Descuento) {
                    strText = "-" + UIUtilFormat._CurrencyFmt(detalle.Valor);
                }
                break;
            case CTableColumns.Recargo:
                if (detalle && detalle.Recargo > 0) {
                    strText = UIUtilFormat._CurrencyFmt(detalle.Recargo);
                }
                break;
            case CTableColumns.PagoAbono:
                if (esPago) {
                    strText = "-" + UIUtilFormat._CurrencyFmt(detalle.Valor);
                }
                break;
            case CTableColumns.Saldo:
                const detalles = (cargo?.Detalles || detalle?.ParentMovimiento.Detalles || []);

                if (cargo && !detalles.length) {
                    strText = UIUtilFormat._CurrencyFmt(cargo.Saldo);
                }
                else if (detalle && detalles[detalles.length - 1] === detalle) {
                    strText = UIUtilFormat._CurrencyFmt(detalle.Saldo);
                }
                break;
            case CTableColumns.FechaVencimiento:
                if (cargo) {
                    strText = UIUtilTime._DateFormatStandar(cargo.FechaVencimiento);
                } else if (detalle && AlumnoEdoCtaUtil.MovDetalleIsPendingOnlinePayment(detalle)) {
                    strText = UIUtilTime._DateFormatStandar(detalle.FechaVencimiento);
                }
                break;
            case CTableColumns.FechaPago:
                if (esPago) {
                    strText = UIUtilTime._DateFormatStandar(detalle.FechaAplicacion);
                }
                break;
            case CTableColumns.MetodoPago:
                if (esPago) {
                    strText = _GetNombreMetodoPago(detalle.IdMetodoPago);
                    if (detalle.IdMetodoPago) {
                        const folioInfo = _DICC_ALUMNO_MOVPAGO_FOLIO.get(detalle.FolioPago);
                        if (folioInfo) {
                            strText += ` - ${UIUtilViewData._GetStr_FinanzaPagoEnLineaFormaPago(folioInfo.FormaPago)}`;
                        }
                    }
                }
                break;
        }
        return strText;
    }

    export function _GetNombreMetodoPago(idMetodoPago: number): string {
        let strText = "";
        if (idMetodoPago) {
            if (idMetodoPago > 0) { // TEMPORAL condición: hasta que OpenPay sea parte de los datos reales
                strText = DataModuloMain._GetDataValueFieldByName("FinanzaMetodoPago", idMetodoPago, "Nombre");
                if (!strText) {
                    strText = _L("general.nodisponible");
                }
            }
            else if (idMetodoPago == ID_METODOPAGO_ENLINEA_TEMP) { // TEMPORAL -1 == OpenPlay
                strText = "OpenPay";
            }
        } else {
            strText = _L("panelfinanzasedocuenta.tag_efectivo");
        }
        return strText;
    }
}